import { createContext } from "react";

export const DeviceInfoContext = createContext();

DeviceInfoContext.displayName = "DeviceInfoContext";
